import { render, staticRenderFns } from "./feedDetail.vue?vue&type=template&id=02701e19&scoped=true"
import script from "./feedDetail.vue?vue&type=script&lang=js"
export * from "./feedDetail.vue?vue&type=script&lang=js"
import style0 from "./feedDetail.vue?vue&type=style&index=0&id=02701e19&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02701e19",
  null
  
)

export default component.exports